module.exports = "::ng-deep.cdk-overlay-dark-backdrop {\n  background : rgba(0, 0, 0, 0.6);\n}\n"